export default "/resources/images/Opella_Workmark_Negative_RGB.svg"